import React from 'react';

export default (props) => {
  const className = props?.className;
  return (
    <div className={className}>Загрузка...</div>
  );
}
